import { getGlobalServiceDocument, hasGlobalServiceDocument } from '@mimir/client-common/globals/backendClient';
import { isLocalStageAccountId } from '@mimir/common/aws/localStage';

/**
 * Not safe to call before the global service document is initialized (e.g. the
 * standalone share-page bundle never initializes it), so this returns false
 * rather than throwing in that case.
 */
export const isRunningOnLocalStage = () =>
  hasGlobalServiceDocument() && isLocalStageAccountId(getGlobalServiceDocument().clientConfig.awsAccountId);
